import normalMode from "../../normalMode";
import O1HD, {managers} from "../../../../engines/gameEngine";
import {getOneHeadUrlById, UserHeadConfig} from "../../config/UserHeadConfig";
import HeadImgNode from "./HeadImgNode";
import NormalGameManager from "../../manager/NormalGameManager";
import { WeChatEvent } from "../../manager/WeChatConst";
import { UIKind } from "../../../define/UIKind";
import ModelDialogLayer from "../../../gameCommon/basic/ModelDialogLayer";
import { PLATFORM_CODE } from "../../../../engines/services/ossService";
import utilsView from "../../../../engines/libs/utilsView";
import { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class UserInfoSettingPrefab extends cc.Component {

    @property({type:cc.Node,displayName:"中心节点"})
    center:cc.Node = null;

    @property(cc.Node)
    soundOpenNode: cc.Node = null;
    @property(cc.Node)
    soundEffectOpenNode: cc.Node = null;
    @property(cc.Node)
    vibrationOpenNode: cc.Node = null;

    @property(cc.Node)
    soundCloseNode: cc.Node = null;
    @property(cc.Node)
    soundEffectCloseNode: cc.Node = null;
    @property(cc.Node)
    vibrationCloseNode: cc.Node = null;

    @property({type:cc.Prefab,displayName:"头像预制体"})
    headImgPrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"内容Layout"})
    contentLayout : cc.Node = null;

    @property({type:cc.Node,displayName:"头像节点"})
    headNode:cc.Node = null;

    /** 用户协议 */
    @property({type: cc.Node, displayName: '用户协议'})
    nodeUserProtocol: cc.Node = null;

    /** 隐私政策 */
    @property({type: cc.Node, displayName: '隐私政策'})
    nodePrivacyPolicy: cc.Node = null;

    private mParentScript : normalMode ;

    /** gm */
    private gmOpenSetIdx = 0;

    closeFun :()=>void = null;

    start(){

        let miniApp = O1HD.getServices().miniGameSrv.getAppApiInstance();
        this.nodeUserProtocol.active = miniApp.isShowUserProtocol();
        this.nodePrivacyPolicy.active = miniApp.isShowPrivacyPolicy();
        
        // this.center.scale = 0.1;
        // cc.tween(this.center).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
        O1HD.on(WeChatEvent.USERUPDATEHEAD,this.updateHead,this);
        this.updateHead();

        NormalGameManager._instance.addOneNodeStrs(UIKind.UILayerTag.USER_SETTING);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.USER_SETTING);
    }

    setSwitchIsVaild(type:string,isVaild:boolean){
        let openNode:cc.Node = null;
        let closeNode:cc.Node = null;
        switch(type){
            case "sound":{
                openNode = this.soundOpenNode;
                closeNode = this.soundCloseNode;
                break;
            }
            case "soundEffect":{
                openNode = this.soundEffectOpenNode;
                closeNode = this.soundEffectCloseNode;
                break;
            }
            case "vibrate":{
                openNode = this.vibrationOpenNode;
                closeNode = this.vibrationCloseNode;
                break;
            }
        }
        openNode.active = isVaild;
        closeNode.active = !isVaild;
    }

    bindData( gameLayer : normalMode ){
        this.mParentScript = gameLayer;
        let userDefineData = UserHeadConfig();
        for ( let userHeadData of userDefineData ) {
            let headPrefabNode = cc.instantiate( this.headImgPrefab );
            this.contentLayout.addChild( headPrefabNode );
            headPrefabNode.getComponent( HeadImgNode ).bindData( userHeadData.id , userHeadData.headPicPath , userHeadData.needWatchAdFlag , this.mParentScript.gameManager );
        }

        let gameData = this.mParentScript.gameManager.getGameData();
        if ( gameData.switchVoice ) {
            this.setSwitchIsVaild("sound",true);
        }else{
            this.setSwitchIsVaild("sound",false);
        }

        if ( gameData.switchVibration ) {
            this.setSwitchIsVaild("vibrate",true);
        }else{
            this.setSwitchIsVaild("vibrate",false);
        }

        if ( gameData.switchVoiceEffect ) {
            this.setSwitchIsVaild("soundEffect",true);
        }else{
            this.setSwitchIsVaild("soundEffect",false);
        }
    }

    protected onBtnSwitchSet(event: any, custom: string) {
        switch (custom) {
            case 'sound': {

                if (this.gmOpenSetIdx == 0 || this.gmOpenSetIdx == 1) {
                    this.gmOpenSetIdx++;
                } else {
                    this.gmOpenSetIdx = 0;
                }

                let switchSound = !this.mParentScript.gameManager.getGameData().switchVoice;
                this.mParentScript.gameManager.setGameData({switchVoice: switchSound } , false );
                if( switchSound ){
                    this.setSwitchIsVaild("sound",true);
                }else{
                    this.setSwitchIsVaild("sound",false);
                }
                managers().soundMgr.setSoundEnabled(switchSound);
                break;
            }
            case 'soundEffect': {

                if (this.gmOpenSetIdx == 2 || this.gmOpenSetIdx == 3) {
                    this.gmOpenSetIdx++;
                } else {
                    this.gmOpenSetIdx = 0;
                }

                let switchEffectSound = !this.mParentScript.gameManager.getGameData().switchVoiceEffect;
                this.mParentScript.gameManager.setGameData(
                    {switchVoiceEffect: switchEffectSound }
                    , false
                );
                if( switchEffectSound ){
                    this.setSwitchIsVaild("soundEffect",true);
                }else{
                    this.setSwitchIsVaild("soundEffect",false);
                }
                managers().soundMgr.setSoundEffect(switchEffectSound);
                break;
            }
            case 'vibrate': {

                if (this.gmOpenSetIdx == 4 || this.gmOpenSetIdx == 5) {
                    this.gmOpenSetIdx++;
                } else {
                    this.gmOpenSetIdx = 0;
                }

                let switchVibration = !this.mParentScript.gameManager.getGameData().switchVibration;
                this.mParentScript.gameManager.setGameData({ switchVibration: switchVibration } , false );
                managers().soundMgr.setVibrateEnabled( switchVibration )
                if( switchVibration ){
                    this.setSwitchIsVaild("vibrate",true);
                }else{
                    this.setSwitchIsVaild("vibrate",false);
                }
                break;
            }
        }
        managers().soundMgr.playSound('anNiu').then();
        managers().soundMgr.playVibrate();
    }


    update(dt) {
    }

    /**
     * 关闭
     */
    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
            this.closeFun && this.closeFun();
            this.node.destroy();
            this.node.removeFromParent();
        // }).start();
    }

    /**
     * 游戏重新开始
     */
    onBtnGameRestart(){

        if (this.gmOpenSetIdx == 8) {
            if (!O1HD.getServices().miniGameSrv.getAppApiInstance().isProduction()) {
                this.openGmLayer();
                return;
            }
        } else {
            this.gmOpenSetIdx = 0;
        }

        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        ModelDialogLayer.show("确定要重新开始吗？", null, ()=> {
            this.mParentScript.onRestartGame();
            this.node.destroy();
            this.node.removeFromParent();
        });
        // cc.tween(this.center).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
        // }).start();
    }

    updateHead(){
        let headUrl = getOneHeadUrlById(NormalGameManager._instance.getGameData().userCurrHead);
        O1HD.getManagers().gameMgr.getCurrMode().bundle.load(`res/user/head/${headUrl}`,cc.SpriteFrame,(err,spr:cc.SpriteFrame)=>{
            if(err){
                console.log(err);
            }else{
                this.headNode.getComponent(cc.Sprite).spriteFrame = spr;
            }
        });
    }

    private clickGmCount = 0;
    onClickGm() {

        if (this.gmOpenSetIdx == 6 || this.gmOpenSetIdx == 7) {
            this.gmOpenSetIdx++;
        } else {
            this.gmOpenSetIdx = 0;
        }

        if (O1HD.getServices().ossSrv.getPlatform() != PLATFORM_CODE.H5) {
            return;
        }
        this.clickGmCount++;
        this.scheduleOnce(()=> {
            this.clickGmCount = 0;
        }, 1);

        if (this.clickGmCount <= 2) {
            return;
        }
        this.clickGmCount = 0;
        this.openGmLayer();
    }

    openGmLayer() {
        utilsView.openPopupLayer(
            'prefab/user/GMLayer'
            , BUNDLE_SMALL_NAME.normalMode
        );
    }

    protected onBtnPrivacy() {
        // cc.sys.openURL(URL_PRIVACY_POLICY);
    }

    protected onBtnUserAgreement() {
        // cc.sys.openURL(URL_USER_AGREEMENT);
    }
}
